module.exports = __webpack_public_path__ + "static/media/g20.bad167af.png";